'use es6';

import { Record } from 'immutable';
export default Record({
  displayOrder: null,
  id: null,
  questionId: null,
  text: null,
  language: null
}, 'Answer');